export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  OPEN_NEW_CONVERSATION: 'OPEN_NEW_CONVERSATION',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  SHOW_PHONE_DIALER: 'showPhoneDialer',
  SHOW_PHONE_AUDIO_SETTINGS: 'showPhoneAudioSettings',
  FOCUS_MESSAGE_EDITOR: 'FOCUS_MESSAGE_EDITOR',
  SHOW_COMMENT_TREE: 'SHOW_COMMENT_TREE',
  PHONE_OPEN_CONVERSATION: 'PHONE_OPEN_CONVERSATION',
  SCROLL_TO_PREVIOUS_CONVERSATIONS: 'SCROLL_TO_PREVIOUS_CONVERSATIONS',
  CONVERSATION_ORDERS_LINKED: 'CONVERSATION_ORDERS_LINKED',
};
